'use client';

import { useState } from 'react';

import { LoadableAction, type LoadableActionProps } from './loadable';
import CheckIcon from '../icons/check.svg';

export interface CopyActionProps extends Omit<LoadableActionProps, 'transition'> {
  children: React.ReactNode;
  copyContent: string;
}

export function CopyAction({ children, copyContent, ...props }: CopyActionProps) {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <LoadableAction
      {...props}
      transition={async () => {
        await navigator.clipboard.writeText(copyContent);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 1500);
      }}
    >
      {isCopied ? <CheckIcon /> : children}
    </LoadableAction>
  );
}
